import { Calendar, CreditCard, Receipt } from "lucide-react";
import { useState } from "react";

const Problem = () => {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  const icons = [
    { Component: CreditCard, index: 0 },
    { Component: Calendar, index: 1 },
    { Component: Receipt, index: 2 },
  ];

  return (
    <section style={styles.section}>
      <div style={styles.container}>
        <div style={styles.content}>
          <div style={styles.iconGrid}>
            {icons.map(({ Component, index }) => (
              <div
                key={index}
                style={{
                  ...styles.iconCard,
                  ...(hoveredIndex === index ? styles.iconCardHover : {}),
                }}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <Component style={styles.icon} />
              </div>
            ))}
          </div>

          <p style={styles.text}>
            Everything is digital now: bills, subscriptions, rent portals,
            autopays. But they all live on different platforms. It's stressful,
            easy to miss something, and hard to feel in control. <br />
            <span style={styles.highlight}>Cura brings it all together.</span>
          </p>
        </div>
      </div>
    </section>
  );
};

const styles: Record<string, React.CSSProperties> = {
  section: {
    padding: "3rem 0",
    width: "100%",
  },
  container: {
    width: "100%",
    margin: "0 auto",
    padding: "0",
  },
  content: {
    maxWidth: "56rem",
    margin: "0 auto",
    padding: "0 1rem",
  },
  iconGrid: {
    display: "flex",
    justifyContent: "center",
    gap: "clamp(1rem, 3vw, 2rem)",
    marginBottom: "2rem",
    flexWrap: "wrap",
  },
  iconCard: {
    padding: "clamp(1rem, 3vw, 1.5rem)",
    backgroundColor: "#fff",
    borderRadius: "0.75rem",
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
    transition: "all 0.3s ease",
    cursor: "pointer",
  },
  iconCardHover: {
    transform: "translateY(-8px)",
    boxShadow: "0 10px 20px rgba(99, 102, 241, 0.2)",
  },
  icon: {
    height: "clamp(2rem, 5vw, 2.5rem)",
    width: "clamp(2rem, 5vw, 2.5rem)",
    color: "#6366f1",
  },
  text: {
    fontSize: "clamp(1rem, 3vw, 1.25rem)",
    color: "#374151",
    lineHeight: 1.75,
    textAlign: "center",
  },
  highlight: {
    fontWeight: "600",
    color: "#6366f1",
  },
};

export default Problem;
